import React from 'react';

import { disabledColor, unit, white } from '@zego/theme';

import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import BlockListSection from '@zego/components/BlockListSection';
import CircledIcon from '@zego/components/CircledIcon';
import PricingOptions from '@zego/components/molecules/PricingOptions';
import SectionDisplay from '@zego/components/SectionDisplay';

import BreakdownIcon from '@zego/static/svgs/breakdown-icon.svg';
import NoClaimsIcon from '@zego/static/svgs/discount-icon.svg';

const PRICING_BREAKDOWN = {
  title: 'Tools to keep you on the road',
  description:
    'We know that keeping moving is really important. To help you stay on the road when things go wrong, we offer Breakdown Cover, and Replacement Vehicle cover to all Zego customers at an additional cost.',
  headerFontSize: 20,
  headerMarginBottom: unit(4),
  listData: [
    {
      heading: 'Breakdown Cover',
      description: 'Combined Roadside, Recovery and Home cover within the UK.',
      itemsPerRow: 2,
      backgroundColor: white,
      textAlign: 'left',
      circleIcon: <CircledIcon src={BreakdownIcon} />,
      footer: <PricingOptions monthlyPrice={8} annualPrice={40} />,
    },
    {
      heading: 'Replacement vehicle',
      description:
        'Get a replacement car licensed for private hire work while yours is in for repair.',
      circleIcon: <CircledIcon src={NoClaimsIcon} />,
      itemsPerRow: 2,
      backgroundColor: white,
      footer: <PricingOptions monthlyPrice={9.3} annualPrice={53} />,
      textAlign: 'left',
    },
  ],
};

const PrivateHirePricingBreakdown = () => (
  <View>
    <SectionDisplay
      css={{
        background: `linear-gradient(to right, ${disabledColor(
          2,
        )}, ${disabledColor(2)}) no-repeat 0 68px`,
      }}
    >
      <Spacer height={unit(11)} />
      <BlockListSection {...PRICING_BREAKDOWN} />
    </SectionDisplay>
  </View>
);

export default PrivateHirePricingBreakdown;
